export default (title, url) => ({
	title: title,
	url: url,
	webShareSupported: false,
	clipboardSupported: false,
	shareFeedback: '',
	copyFeedback: '',

	init() {
		this.webShareSupported = navigator.share !== undefined ? true : false;
		this.clipboardSupported =
			navigator.clipboard !== undefined ? true : false;
	},

	noOptionsAvailable() {
		return !this.clipboardSupported && !this.webShareSupported;
	},

	share() {
		navigator
			.share({
				title,
				url,
				text: title,
			})
			.then(() => {
				this.shareFeedback = 'Thanks!';

				setTimeout(() => {
					this.shareFeedback = '';
				}, 3000);
			})
			.catch((error) => console.error('Error sharing', error));
	},

	copyLink() {
		navigator.clipboard
			.writeText(url)
			.then(() => {
				this.copyFeedback = 'Link copied!';

				setTimeout(() => {
					this.copyFeedback = '';
				}, 3000);
			})
			.catch((error) => console.error(error));
	},
});
